<template>
  <section class="moz-container">
    <mozio-search-form v-bind="adaptedConfig">
      <app-mozio
        slot-scope="{ updatedConfig, events }"
        :from="updatedConfig.from"
        :to="updatedConfig.to"
        :currency="updatedConfig.currency"
        :passengers="updatedConfig.passengers"
        :mode="updatedConfig.mode"
        :locale="updatedConfig.locale"
        :clarified-search="updatedConfig.clarifiedSearch"
        @empty-result="events.onEmptyResult"
      />
    </mozio-search-form>
  </section>
</template>

<script>
import { Mozio, MozioSearchForm } from '@/modules';

export default {
  name: 'App',
  components: {
    AppMozio: Mozio,
    MozioSearchForm,
  },
  props: {
    config: {
      type: Object,
      default: () => ({
        from: '',
        to: '',
        currency: 'USD',
        passengers: 1,
        /**
         *  no-results если нет маршрута/трансфера Kiwitaxi
         *  no-sales есть трансферы Kiwitaxi, продаж не было
         *  no-capacity нет трансферов, подходящих по вместимости
         */
        mode: 'no-results',
        locale: 'ru',
        placeFromTypeId: '',
        placeToTypeId: '',
        route_falsity: 0,
      }),
    },
  },
  computed: {
    adaptedConfig() {
      const { route_falsity: routeFalsity } = this.config;

      return {
        ...this.config,
        routeFalsity,
      };
    },
  },
};
</script>
